var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJacLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 23,
    viewBox: "0 0 78 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9514 17.7198H32.6054C33.9196 17.7198 35.1805 17.1337 36.0151 16.1215L41.9998 8.8581C42.2662 8.52068 42.0709 8.02344 41.6269 8.02344H39.0874C38.821 8.02344 38.5724 8.14775 38.4126 8.3431L32.6232 15.3934C31.6287 16.601 30.4744 16.7963 29.3556 16.7963L25.5019 16.8141C25.3776 16.8141 25.2177 16.9029 25.1467 17.0094L24.827 17.4889C24.756 17.5777 24.827 17.7198 24.9514 17.7198Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8549 17.0222L41.9627 13.1686C42.6731 12.2806 43.7563 11.7656 44.8929 11.7656H49.3681C49.4747 11.7656 49.5457 11.7834 49.599 11.8722L49.9009 12.2984C50.0075 12.4405 49.9009 12.6358 49.7233 12.6358H46.8109C45.9229 12.6358 45.0705 13.0443 44.5022 13.7369L41.5543 17.3597C41.3767 17.5905 41.0925 17.7148 40.7906 17.7148H39.1213C38.8016 17.7148 38.624 17.3064 38.8549 17.0222Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2322 8.9057H48.2635C49.3112 8.9057 50.3057 9.36743 50.9628 10.1843L56.8587 17.3589C57.0719 17.6253 57.3915 17.7674 57.7289 17.7674H60.1619C60.5881 17.7674 60.819 17.2701 60.5526 16.9505L54.3725 9.47398C53.6089 8.53277 52.3835 8 50.5899 8H44.765C44.6229 8 44.4808 8.07104 44.4098 8.19535L44.0724 8.67484C44.0191 8.76363 44.0901 8.9057 44.2322 8.9057Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7924 8.14481L69.1298 8.6243C69.2186 8.73085 69.1298 8.90844 68.9877 8.90844H61.8487C61.4225 8.90844 61.2094 9.35241 61.5468 9.76086L66.1108 15.3194C66.9455 16.3849 67.94 16.8111 69.5027 16.8111H73.2854C73.4274 16.8111 73.5695 16.8822 73.6406 17.0065L73.9602 17.4682C74.0312 17.5748 73.9602 17.7168 73.8359 17.7168L66.093 17.7346C64.7966 17.7168 63.7666 17.2196 62.7366 16.083L56.8052 8.87292C56.521 8.5355 56.7341 8.00274 57.1603 8.00274H68.4905C68.597 7.98498 68.7213 8.05602 68.7924 8.14481Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacLogo);
export default ForwardRef;